import { observer } from 'mobx-react';
import PinIndicator from './PinIndicator';
import PinGuideTextArea from './PinGuideTextArea';
import PinNumberPad from './PinNumberPad';
import useJoinPinSettingView from '../useJoinPinSettingView';

const JoinPinSettingView = observer(() => {
    const {pin,checkPin, isCheckView,isPinCheckFailed, onClickNumberBtn, OnClickDeleteBtn, onClickAllClearBtn} = useJoinPinSettingView();
    

    return (
        <div className="wrap wrap_temporary pin join-pin">
            <div className="container" style={{ marginTop: '17rem' }}>
                <h2 className="fw-b">{isCheckView ? 'PIN 비밀번호 확인' : 'PIN 비밀번호 설정이 필요합니다.'}</h2>
                <p className="body-s-n fw-b">{isCheckView ? '다시 한번 입력해주세요.' : '6자리 숫자로 입력해주세요.'}</p>
                <PinIndicator pin={pin} checkPin={checkPin} isCheckView={isCheckView} />
                <PinGuideTextArea isPinCheckFailed={isPinCheckFailed} />
                <PinNumberPad
                    onClickNumberBtn={onClickNumberBtn}
                    OnClickDeleteBtn={OnClickDeleteBtn}
                    onClickAllClearBtn={onClickAllClearBtn}
                />
            </div>
        </div>
    );
});

export default JoinPinSettingView;  